'use client';
import { useSearchParams } from 'next/navigation';

export default function useRouterQueryKeyValue(queryIdName: string): {
    queryKey: string;
    queryValue: string | null;
    exists: boolean;
} {
    const searchParams = useSearchParams();

    const queryId: string | null = searchParams.get(queryIdName);

    return {
        queryKey: queryIdName,
        queryValue: queryId,
        exists: !!queryId
    };
}

export function getValueFromUrlQuery(query: Record<string, unknown>, key: string): string | null {
    const value = query?.[key];
    return typeof value === 'string' ? value : null;
}
